function extrairItens(response) {
  const data = response?.data || response;
  if (Array.isArray(data?.titulos)) return data.titulos;
  if (Array.isArray(data?.content)) return data.content;
  return Array.isArray(data) ? data : [];
}

export async function coletarItensPaginados(carregarPagina, pageSize) {
  const primeiraPagina = await carregarPagina(1);
  const data = primeiraPagina?.data || {};
  const primeiraLista = extrairItens(primeiraPagina);
  const totalRegistros = Number(
    data.totalRegistros ?? data.totalElements ?? primeiraLista.length
  );
  const tamanhoPagina = Number(data.tamanhoPagina ?? data.size ?? pageSize);
  const totalPaginas = Number(
    data.totalPaginas ??
      data.totalPages ??
      (totalRegistros ? Math.ceil(totalRegistros / tamanhoPagina) : 0)
  );

  if (!totalRegistros || totalPaginas <= 1) return primeiraLista;

  const itens = [...primeiraLista];
  for (let page = 2; page <= totalPaginas; page += 4) {
    const respostas = await Promise.all(
      Array.from({ length: Math.min(4, totalPaginas - page + 1) }, (_, index) =>
        carregarPagina(page + index)
      )
    );
    respostas.forEach((resposta) => itens.push(...extrairItens(resposta)));
  }
  return itens;
}
